/**
 * EDM normalisation in the browser (Tata AIA 3.6 T-19).
 *
 * A value is normalised the dataset's way BEFORE it is salted and hashed, at
 * upload and when testing a value. The controller
 * (apps/api-controller/src/modules/discovery/edm/normalise.ts) and the edge
 * scanner (apps/edge-discovery/src/tenant_classifiers.rs) normalise sampled
 * values the same way; all three are tested against
 * interop/detectors/tenant-classifier-vectors.json. A difference of one byte
 * means every match silently misses, so do not change one copy alone.
 */
import type { EdmNormalisation } from '@/lib/api';

export const EDM_NORMALISATION_OPTIONS: ReadonlyArray<{ value: EdmNormalisation; label: string; hint: string }> = [
  { value: 'exact', label: 'Exact', hint: 'Matched exactly as written (spaces around a value are ignored).' },
  { value: 'case_insensitive', label: 'Ignore case', hint: 'abcpe1234f matches ABCPE1234F.' },
  {
    value: 'alphanumeric',
    label: 'Ignore case, spaces and punctuation',
    hint: '1234 5678-9012 matches 123456789012. For identifiers only, not for names.',
  },
];

function upperAscii(s: string): string {
  return s.replace(/[a-z]/g, (c) => c.toUpperCase());
}

// eslint-disable-next-line no-control-regex
const ASCII_NON_ALNUM = /[\x00-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]/g;

export function normaliseEdmValue(value: string, mode: EdmNormalisation): string {
  const t = value.trim();
  switch (mode) {
    case 'exact':
      return t;
    case 'case_insensitive':
      return upperAscii(t);
    case 'alphanumeric':
      return upperAscii(t.replace(ASCII_NON_ALNUM, ''));
  }
}
